var initVideoSequence = function() {
  var videoSequence = $('.kef-video-sequence');

  if (videoSequence.length > 0) {
    var videoPlayer = {}

    // fix video player settings
    var videoSequence = $('.kef-video-sequence');
    videoSequence.each(function() {
      var player_params = $('.video-player-params', this),
          player_params_config = player_params.text(),
          new_player_params_config = '';
      do {
        player_params_config = new_player_params_config || player_params_config;
        new_player_params_config = general.decodeEntity(player_params_config);
      } while (new_player_params_config != player_params_config);
      player_params.html(JSON.stringify(JSON.parse(player_params_config)));
    });

    // read video player settings
    videoSequence = $('.kef-video-sequence');
    videoSequence.each(function(i) {
      var player = $('.video-player', this);
      var player_id = `video-sequence-${i}`;
      player.attr('data-id', player_id);
      videoPlayer[player_id] = {
        player: player,
        has_play: false,
      };
    });
    var wait_for_player = setInterval( function() {
      if(typeof video_player !== 'undefined') {
        clearInterval(wait_for_player);
        video_player.init();
      }
    }, 100);


    initVideoSequenceScroll();
    $(window).on('scroll', initVideoSequenceScroll);

    $(document).on('video_worker_play', function(e) {
      if (typeof e.video.url != 'undefined' && (e.video.url.indexOf('muo/img-stn00-mb.mp4') >= 0 || e.video.url.indexOf('muo/img-stn00-dt-tb.mp4') >= 0)) {
        setTimeout(() => {
          var video_el = $(e.video.player);
          video_el.parents('.kef-video-sequence').addClass('active');
        }, 3000);
      }
    });

    $(document).on('video_worker_ended', function(e) {
      var video_el = $(e.video.player);
      video_el.parents('.kef-video-sequence').addClass('active');
    });

    function initVideoSequenceScroll() {
      var scrollTop = $(window).scrollTop();
      var windowHeight = window.innerHeight;
      
      videoSequence = $('.kef-video-sequence');
      if (videoSequence.length == 0) return;
      videoSequence.each(function() {
        var player = $('.video-player', this),
            player_id = player.attr('data-id'),
            playerObj = videoPlayer[player_id];

        var videoOffset = $(this).offset().top;
        var videoHeight = $(this).outerHeight();
        
        // var scrollProgress = (scrollTop - (videoOffset - windowHeight)) / (videoHeight + windowHeight);
        var scrollProgress = videoOffset - (windowHeight * 0.5);
        
        if (scrollTop > scrollProgress && ! playerObj.has_play) {
          video_player.play(playerObj.player);
          playerObj.has_play = true;
        }
      });
    }
  }
}
document.addEventListener('DOMContentLoaded', function() {
  var intv = setInterval(() => {
    if(typeof video_player !== 'undefined') {
      clearInterval(intv);
      initVideoSequence();
    }
  }, 200);
});